import { render } from "./CoopScoop.vue?vue&type=template&id=6c6cd6b1&scoped=true&ts=true"
import script from "./CoopScoop.vue?vue&type=script&lang=ts"
export * from "./CoopScoop.vue?vue&type=script&lang=ts"

import "./CoopScoop.vue?vue&type=style&index=0&id=6c6cd6b1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6cd6b1"]])

export default __exports__